import { LOCALE_ID, NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, provideHttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpService } from './shared/services/http.service';
import { AppService } from './shared/services/app.service';
import { AuthService } from './shared/services/auth.service';
import { provideRouter, RouterModule, withHashLocation } from '@angular/router';
import { routes } from './app.routes';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { CommonModule, registerLocaleData } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TransactionsService } from './shared/services/transactions.service';
import { UtilsService } from './shared/services/utils.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { UserService } from './shared/services/users.service';
import { SwapService } from './shared/services/swap.service';
import { VerificationsService } from './shared/services/verifications.service';
import { PdfGeneratorService } from './shared/services/pdf_generator.service';
import localeEs from '@angular/common/locales/es';
import { LoggerService } from './shared/services/logger.service';
import { MovementsService } from './shared/services/movements.service';
import { UploadService } from './shared/services/upload.service';
import { VirtualCardsService } from './shared/services/virtual_cards.service';
import { ProvidersCashinService } from './shared/services/cashin.service';
import { BankTransactionsService } from './shared/services/bank-transactions.service';
import { PaymentDeclarationsService } from './shared/services/payment_declarations.service';
import { SupportTicketsService } from './shared/services/support-tickets.service';
import { RatesService } from './shared/services/rates.service';
import { ExchangesService } from './shared/services/exchanges.service';
import { TransfersService } from './shared/services/transfers.service';
import { TasadorService } from './shared/services/tasador.service';
import { ProviderServiceService } from './shared/services/provider_service.service';
import { FeesService } from './shared/services/fees.service';

registerLocaleData(localeEs, 'es-VE');
@NgModule({
  declarations: [AppComponent],
  imports: [
    CommonModule,
    RouterModule,
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    SharedModule,
    ToastModule,
  ],
  providers: [
    provideRouter(routes /* , withHashLocation() */),
    provideHttpClient(),
    { provide: LOCALE_ID, useValue: 'es-VE' },
    AuthService,
    AppService,
    UserService,
    HttpService,
    TransactionsService,
    UtilsService,
    ConfirmationService,
    MessageService,
    SwapService,
    VerificationsService,
    PdfGeneratorService,
    LoggerService,
    MovementsService,
    UploadService,
    VirtualCardsService,
    ProvidersCashinService,
    BankTransactionsService,
    PaymentDeclarationsService,
    SupportTicketsService,
    RatesService,
    ExchangesService,
    TransfersService,
    TasadorService,
    ProviderServiceService,
    FeesService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {}
}
